import { ECardType } from './config';

export const normalHex = /^#([0-9a-f]{2}){3}$/i;
export const shortHex = /^#([0-9a-f]){3}$/i;

export const accountNumber = '(^[0-9]{1,17}$)|(^[x]{13}[0-9]{4}$)';
export const cvv3Digits = '[0-9]{3}';
export const cvv4Digits = '[0-9]{4}';
export const expiration = '(0[1-9]|1[0-2])/?([0-9]{2})';
export const routingNumber = '[0-9]{9}';

export const cardPatterns: Record<ECardType, string> = {
  [ECardType.VISA]: '4[0-9]{12}(?:[0-9]{3})?(?:[0-9]{3})?',
  [ECardType.MASTERCARD]:
    '(5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}',
  [ECardType.AMEX]: '3[47][0-9]{13}',
  [ECardType.DISCOVER]: '6(?:011|5[0-9]{2})[0-9]{12}(?:[0-9]{3})?',
  [ECardType.JCB]: '35(2[89]|[3-8][0-9])[0-9]{12}(?:[0-9]{3})?',
  [ECardType.PREDEFINED]: '[x]{12}(?:[0-9]{1,4})',
};

export const cardPrefixRegexes: Record<string, RegExp> = {
  [ECardType.VISA]: /^4[0-9]{3}/,
  [ECardType.MASTERCARD]:
    /^(5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)/,
  [ECardType.AMEX]: /^3[47]/,
  [ECardType.DISCOVER]: /^6(?:011|5[0-9]{2})/,
  [ECardType.JCB]: /^35(2[89]|[3-8][0-9])/,
};
